import { SpaceBetween } from '@amzn/awsui-components-core';
import {
  ContentQualityQuestionData,
  ContentQualityResponseOptions,
  ContentType,
  QuestionResponse,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import QuestionnaireCategoryBox from './QuestionnaireCategoryBox';

interface Props {
  categories: string[];
  categoryToSequencesMap: Map<string, number[]>;
  sequenceToQuestionMap: Map<number, ContentQualityQuestionData>;
  sequenceToVisibilityMap?: Map<number, boolean>;
  sequenceToResponseMap: Map<number, QuestionResponse>;
  handleResponseUpdated?: (
    sequence: number,
    response: ContentQualityResponseOptions,
    comment: string,
  ) => void;
  contentType: ContentType;
  isReadOnly?: boolean;
}

const ContentQualityQuestionnaireForm: React.FunctionComponent<Props> = (props: Props) => {
  const {
    categories,
    categoryToSequencesMap,
    sequenceToQuestionMap,
    sequenceToVisibilityMap,
    sequenceToResponseMap: responseMap,
    handleResponseUpdated,
    contentType,
  } = props;

  const questionsInCategories = categories.map((category, index) => {
    const sequences = categoryToSequencesMap.get(category) as number[];
    return (
      <div key={category}>
        <QuestionnaireCategoryBox
          key={category}
          category={category}
          sequences={sequences}
          sequenceToQuestionMap={sequenceToQuestionMap}
          sequenceToVisibilityMap={sequenceToVisibilityMap}
          sequenceToResponseMap={responseMap}
          handleResponseUpdated={handleResponseUpdated}
          contentType={contentType}
          readonly={props.isReadOnly}
        />
      </div>
    );
  });

  return (
    <SpaceBetween direction="vertical" size="m">
      {questionsInCategories}
    </SpaceBetween>
  );
};

export default ContentQualityQuestionnaireForm;
